import {Locales} from '@netx/core-next/locales/utils/Locales';

export const SelectLabels = Locales((i18n) => ({
	CLEAR: i18n('i18n.clear'),
}));
